import axios from "axios"
import { toast } from "sonner"

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true,
  withXSRFToken: true,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
})

// Fallback request interceptor — manually read XSRF cookie if Axios didn't
api.interceptors.request.use((config) => {
  if (!config.headers["X-XSRF-TOKEN"]) {
    const token = document.cookie
      .split("; ")
      .find((row) => row.startsWith("XSRF-TOKEN="))
      ?.split("=")
      .slice(1)
      .join("=")

    if (token) {
      config.headers["X-XSRF-TOKEN"] = decodeURIComponent(token)
    }
  }

  return config
})

// Response interceptor — handle common errors
// Note: 401 redirects are handled by ProtectedRoute, not here.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status

    if (status === 429) {
      const retryAfter = error.response?.headers?.["retry-after"]
      const seconds = retryAfter ? parseInt(retryAfter, 10) : 60
      toast.error(`Trop de requêtes. Réessayez dans ${seconds} secondes.`)
    }

    if (status === 403) {
      const message = error.response?.data?.message ?? ""
      if (message.includes("double authentification") && !window.location.pathname.startsWith("/profile")) {
        window.location.href = "/profile"
      }
    }

    if (status === 409) {
      const message =
        error.response?.data?.message ?? "Conflit : cette action est impossible."
      toast.error(message)
    }

    if (status === 502) {
      const message: string = error.response?.data?.message ?? ""
      if (message.toLowerCase().includes("visioconférence")) {
        toast.error(
          "Le service de visioconférence est temporairement indisponible. Le lien sera créé automatiquement dès que possible.",
        )
      }
    }

    return Promise.reject(error)
  }
)

export { api }
